/* Mobiele knop op de productkaart: klapt de geurnoten-overlay open/dicht.
   Event delegation, zodat het ook werkt na AJAX-filteren en 'meer laden'. */
(function () {
  if (window.cardNotenInit) return;
  window.cardNotenInit = true;

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.card-noten-knop');
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();

    var kaart = knop.closest('.card-wrapper');
    if (!kaart) return;

    var open = kaart.classList.toggle('is-noten-open');
    knop.setAttribute('aria-expanded', open ? 'true' : 'false');
    knop.setAttribute('aria-label', open ? 'Verberg geurnoten' : 'Toon geurnoten');
  });
})();
